module.exports = __webpack_public_path__ + "static/hero-765d47560d7944f1357449f9b5de28b0.svg";